import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarrantyModel } from "src/models/Products/WarrantyModel.models";

interface WarrantyModelState {
  warrantyModels: IWarrantyModel[];
  warrantyModelToEdit: IWarrantyModel | null;
}

const initialState: WarrantyModelState = {
  warrantyModels: [],
  warrantyModelToEdit: null,
};

const warrantyModelSlice = createSlice({
  name: "WarrantyModel",
  initialState,
  reducers: {
    setWarrantyModelList: (state, action: PayloadAction<IWarrantyModel[]>) => {
      state.warrantyModels = action.payload;
    },
    concatListWarrantyModel: (
      state: WarrantyModelState,
      action: PayloadAction<IWarrantyModel[]>
    ) => {
      state.warrantyModels = [...state.warrantyModels.concat(action.payload)];
    },
    setWarrantyModelToEdit: (
      state,
      action: PayloadAction<IWarrantyModel | null>
    ) => {
      state.warrantyModelToEdit = action.payload;
    },
    addWarrantyModel: (state, action: PayloadAction<IWarrantyModel>) => {
      state.warrantyModels.push(action.payload);
    },
    updateWarrantyModel: (state, action: PayloadAction<IWarrantyModel>) => {
      let itemIndex = state.warrantyModels.findIndex(
        item => item.warrantyModelId === action.payload.warrantyModelId
      );
      if (itemIndex !== -1) state.warrantyModels[itemIndex] = action.payload;
    },
    deleteWarrantyModel: (state, action: PayloadAction<number>) => {
      const newArray = state.warrantyModels.filter(
        item => item.warrantyModelId !== action.payload
      );
      state.warrantyModels = newArray;
    },
  },
});

export const {
  setWarrantyModelList,
  concatListWarrantyModel,
  setWarrantyModelToEdit,
  addWarrantyModel,
  updateWarrantyModel,
  deleteWarrantyModel,
} = warrantyModelSlice.actions;

export default warrantyModelSlice.reducer;
